import { render, staticRenderFns } from "./InformationConsumables.vue?vue&type=template&id=16c2b8c1&scoped=true"
import script from "./InformationConsumables.vue?vue&type=script&lang=js"
export * from "./InformationConsumables.vue?vue&type=script&lang=js"
import style0 from "./InformationConsumables.vue?vue&type=style&index=0&id=16c2b8c1&prod&scoped=true&lang=css"
import style1 from "./InformationConsumables.vue?vue&type=style&index=1&id=16c2b8c1&prod&lang=css"
import style2 from "./InformationConsumables.vue?vue&type=style&index=2&id=16c2b8c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2b8c1",
  null
  
)

export default component.exports